import React, { useRef } from 'react'

import { SnackbarProvider } from 'notistack'
import { compose } from 'recompose'
import { withNamespaces } from 'react-i18next'

import { withStyles as muiWithStyles } from '@material-ui/core/styles'

import MuiIconNewReleasesOutlined from '@material-ui/icons/NewReleasesOutlined'
import MuiButton from '@material-ui/core/Button'

const styles = {
  info: {
    color: 'rgba(3, 169, 244, 1)',
    border: '1px solid rgba(3, 169, 244, 1)',
    backgroundColor: 'rgba(225, 245, 254, 1)',
    borderRadius: '4px'
  },
  error: {
    color: 'rgba(244, 67, 54, 1)',
    border: '1px solid rgba(244, 67, 54, 1)',
    backgroundColor: 'rgba(253, 235, 233, 1)',
    borderRadius: '4px'
  },
  warning: {
    color: 'rgba(255, 193, 7, 1)',
    border: '1px solid rgba(255, 193, 7, 1)',
    backgroundColor: 'rgba(255, 236, 179, 1)',
    borderRadius: '4px'
  },
  success: {
    color: 'rgba(102, 187, 106, 1)',
    border: '1px solid rgba(102, 187, 106, 1)',
    backgroundColor: 'rgba(232, 245, 233, 1)',
    borderRadius: '4px'
  }
}

const Snackbar = ({ t, classes, children }) => {
  const notistackRef = useRef()

  return (
    <SnackbarProvider
      ref={notistackRef}
      maxSnack={6}
      classes={{
        variantInfo: classes.info,
        variantError: classes.error,
        variantWarning: classes.warning,
        variantSuccess: classes.success
      }}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right'
      }}
      iconVariant={{
        success: <MuiIconNewReleasesOutlined style={{ marginRight: '10px' }} />,
        error: <MuiIconNewReleasesOutlined style={{ marginRight: '10px' }} />,
        warning: <MuiIconNewReleasesOutlined style={{ marginRight: '10px' }} />,
        info: <MuiIconNewReleasesOutlined style={{ marginRight: '10px' }} />
      }}
      action={key => (
        <MuiButton
          id="snackbar-btn-fechar"
          color="inherit"
          size="small"
          onClick={() => notistackRef.current.closeSnackbar(key)}
        >
          {t('global_fechar')}
        </MuiButton>
      )}
    >
      {children}
    </SnackbarProvider>
  )
}

const withStyles = compose(withNamespaces('translation'), muiWithStyles(styles))

export default withStyles(Snackbar)
